export default __webpack_public_path__ + "static/media/bateria1.257a4225.png";